import React from 'react';
import { Accordion as BootstrapAccordion } from 'react-bootstrap';

const Accordion = ({ 
    items = [], 
    defaultActiveKey,
    alwaysOpen = false,
    flush = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapAccordion 
            defaultActiveKey={defaultActiveKey}
            alwaysOpen={alwaysOpen}
            flush={flush}
            className={className} 
            style={style}
            {...props}
        >
            {items.map((item, index) => (
                <BootstrapAccordion.Item key={index} eventKey={item.key || index.toString()}>
                    <BootstrapAccordion.Header>{item.header || item.title}</BootstrapAccordion.Header>
                    <BootstrapAccordion.Body>{item.body || item.content}</BootstrapAccordion.Body>
                </BootstrapAccordion.Item>
            ))}
        </BootstrapAccordion>
    );
};

export default Accordion;

